const ValidationCardStatus = [
    'Pending Validation Card',
    'No Data Entry',
    'Data Entry - In Progress',
    'Ready for Validation',
    'Validated and Submitted'
];

export default ValidationCardStatus;


// WEBPACK FOOTER //
// ./src/constants/ValidationCardStatus.js